package com.exura.pages.planCreator.components.seriesViews.sections

import androidx.compose.runtime.*
import com.exura.pages.planCreator.components.seriesViews.inputs.ModeOption
import com.exura.pages.planCreator.components.seriesViews.inputs.ModeSelectorInput
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorInputMode
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorIntegerInput
import com.exura.ui.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px

enum class SpawnMode {
    TIMES, FOR_DAYS; // Removed SINGLE
}

fun spawnModeOption(
    mode: SpawnMode,
    spawnCount: Int,
    spawnForDays: Int,
    inputMode: PlanCreatorInputMode,
    onSpawnCountChange: (Int) -> Unit,
    onSpawnForDaysChange: (Int) -> Unit,
    onModeChange: (SpawnMode) -> Unit = {  },
): ModeOption<SpawnMode> = when (mode) {
    SpawnMode.TIMES -> ModeOption(
        onClick = { onModeChange(SpawnMode.TIMES) }
    ) {
        Row(horizontalArrangement = Arrangement.spacedBy(12.px)) {
            SpanText("Powtórz")
            PlanCreatorIntegerInput(
                value = spawnCount,
                onValueChange = { newValue ->
                    onSpawnCountChange(newValue)
                },
                mode = inputMode,
                placeholder = "",
                textStyle = TextStyles.medium16,
                minValue = 1
            )
            SpanText("razy")
        }
    }
    SpawnMode.FOR_DAYS -> ModeOption(
        onClick = { onModeChange(SpawnMode.FOR_DAYS) }
    ) {
        Row(horizontalArrangement = Arrangement.spacedBy(12.px), verticalAlignment = Alignment.CenterVertically) {
            SpanText("Przez")
            PlanCreatorIntegerInput(
                value = spawnForDays,
                onValueChange = { newValue ->
                    onSpawnForDaysChange(newValue)
                },
                mode = inputMode,
                placeholder = "",
                textStyle = TextStyles.medium16,
                minValue = 1
            )
            SpanText("dni")
        }
    }
}

@Composable
internal fun SpawnModeSection(
    selectedValue: SpawnMode,
    spawnCount: Int,
    spawnForDays: Int,
    onSpawnCountChange: (Int) -> Unit,
    onSpawnForDaysChange: (Int) -> Unit,
    onModeChange: (SpawnMode) -> Unit = {  },
    mode: PlanCreatorInputMode,
    enabled: Boolean = true,
) = EditViewSection(
    enabled = enabled,
    title = "Jak długo?",
    modifier = Modifier.padding(topBottom = 0.px).minHeight(100.px).height(100.px),
    withTitle = false,
) {
    ModeSelectorInput(
        options = listOf(SpawnMode.TIMES, SpawnMode.FOR_DAYS), // Removed SINGLE
        optionToMode = { spawnMode ->
            spawnModeOption(
                mode = spawnMode,
                spawnCount = spawnCount,
                spawnForDays = spawnForDays,
                inputMode = mode,
                onSpawnCountChange = onSpawnCountChange,
                onSpawnForDaysChange = onSpawnForDaysChange,
                onModeChange = onModeChange,
            )
        },
        selectedValue = selectedValue,
        mode = mode,
        enabled = enabled,
    )
}
